import { useQueryDetails } from '@gogame/query';

import { loadFinancialResultDetails } from 'scenes/FinancialResults/sources/financialResults';

import { details } from './queryKeyFactory';

export const useLoadFinancialResultsDetails = id => {
  return useQueryDetails(details(id), () => loadFinancialResultDetails({ id }));
};
